var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandardIconBloc',{attrs:{"icon":"exclamation-triangle-fill","backColor":"rgb(255,250,230)","frontColor":"rgb(255,153,31)"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }